import type { PayloadAction } from '@reduxjs/toolkit';

import { createSlice } from '@reduxjs/toolkit';

const initialState: { isDirty: boolean } = {
  isDirty: false,
};

const formIsDirtySlice = createSlice({
  name: 'formIsDirty',
  initialState,
  reducers: {
    setFormDirty: (state, action: PayloadAction<boolean>) => {
      state.isDirty = action.payload;
    },
  },
});

export const { setFormDirty } = formIsDirtySlice.actions;

export const formIsDirtyReducer = formIsDirtySlice.reducer;
